import { render, staticRenderFns } from "./itineraryDisplay.vue?vue&type=template&id=6148a41a&scoped=true&"
import script from "./itineraryDisplay.vue?vue&type=script&lang=js&"
export * from "./itineraryDisplay.vue?vue&type=script&lang=js&"
import style0 from "./itineraryDisplay.vue?vue&type=style&index=0&id=6148a41a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6148a41a",
  null
  
)

export default component.exports